import { FC, Fragment, ReactNode } from 'react';
import Card from '@/components/card';
import { Box, Stack } from '@mui/material';
import CardHeader from '../card/card-header';
import NoneChip from '../chip/none-chip';
import { IconType } from '../icon/helpers';

type ListCardItem = {
  id: string;
  name: string;
};

interface Props {
  title: string;
  icon: IconType;
  items: ListCardItem[];
  onRenderItem?: (item: ListCardItem) => ReactNode;
}

const ListCard: FC<Props> = ({ items, title, icon, onRenderItem }) => {
  const hasItems = !!items.length;

  return (
    <Card>
      <CardHeader title={title} icon={icon} />
      <Box>
        {!hasItems && <NoneChip />}
        {hasItems && (
          <Stack gap={1} mt={2}>
            {items.map((item) => {
              if (onRenderItem) {
                return <Fragment key={item.id}>{onRenderItem(item)}</Fragment>;
              }
              return <Box key={item.id}>{item.name}</Box>;
            })}
          </Stack>
        )}
      </Box>
    </Card>
  );
};

export default ListCard;
